<template>
  <div>
    <div class="ant-pro-pages-list-projects-cardList">
      <a-list :loading="loading" :data-source="data" :grid="{ gutter: 6, xl: 8, lg: 3, md: 3, sm: 2, xs: 1 }">
        <a-list-item slot="renderItem" slot-scope="item" @click="initWarehouse(item)">
          <a-card class="ant-pro-pages-list-projects-card" hoverable>
            <!--            <img slot="cover" :src="item.cover" :alt="item.warehouse.name" />-->
            <a-card-meta :title="item.name" style="{text-align:center}">
              <!--              <template slot="description">-->
              <!--                <ellipsis :length="50">{{ item.warehouse.name }}</ellipsis>-->
              <!--              </template>-->
            </a-card-meta>
            <div class="cardItemContent">
              <!--              <span>{{ item.updatedAt | fromNow }}</span>-->
              <div class="avatarList">
                <avatar-list size="mini">
                  <avatar-list-item
                    v-for="(member, i) in item.members"
                    :key="`${item.id}-avatar-${i}`"
                    :src="member.avatar"
                    :tips="member.name"
                  />
                </avatar-list>
              </div>
            </div>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import moment from 'moment'
import { TagSelect, StandardFormRow, Ellipsis, AvatarList } from '@/components'
import { Warehouse } from '@/api/dto/common/Warehouse'

const TagSelectOption = TagSelect.Option
const AvatarListItem = AvatarList.AvatarItem

export default {
  components: {
    AvatarList,
    AvatarListItem,
    Ellipsis,
    TagSelect,
    TagSelectOption,
    StandardFormRow
  },
  data() {
    return {
      data: [],
      form: this.$form.createForm(this),
      loading: true
    }
  },
  filters: {
    fromNow(date) {
      return moment(date).fromNow()
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleChange(value) {
      console.log(`selected ${value}`)
    },
    getList() {
      const operator = Vue.ls.get(OPERATOR)
      this.data = operator.warehouses
      this.loading = false
    },
    initWarehouse(item) {
      const warehouse = new Warehouse()
      Object.assign(warehouse, item)
      console.log('warehouse', warehouse)
      Vue.ls.set(WAREHOUSE, warehouse)
      this.$router.push({ name: 'workLayout' })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-pro-components-tag-select {
  /deep/ .ant-pro-tag-select .ant-tag {
    margin-right: 24px;
    padding: 0 8px;
    font-size: 14px;
  }
}

.ant-pro-pages-list-projects-cardList {
  margin-top: 24px;
  margin-left: 8px;

  /deep/ .ant-card-meta-title {
    /*margin-bottom: 4px;*/
    display: flex;
  }

  /deep/ .ant-card-meta-description {
    height: 44px;
    overflow: hidden;
    line-height: 22px;
  }

  .cardItemContent {
    display: flex;
    height: 10px;
    margin-top: 16px;
    margin-bottom: -4px;
    line-height: 20px;

    > span {
      flex: 1 1;
      color: rgba(0, 0, 0, .45);
      font-size: 12px;
    }

    /deep/ .ant-pro-avatar-list {
      flex: 0 1 auto;
    }
  }
}
</style>
